// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c5623077","667":"494fbeab","977":"b563a953"}[chunkId] + ".chunk.js";
};